import { mapState, mapActions, mapGetters } from 'vuex'

//parallax related props
export const parallaxFunctions = {
  computed: {
    ...mapState(['disableParallax']),
  },
}

//modal related props
export const modalFunctions = {
  computed: {
    ...mapState(['modalOpen']),
  },
  methods: {
    ...mapActions(['showModal', 'hideModal']),
  },
}

//ligtbox related props
export const lightboxFunctions = {
  computed: {
    ...mapState(['modalOpen']),
  },
  methods: {
    ...mapActions(['showModal', 'hideModal', 'setLightboxData']),
    openLightbox(data) {
      this.setLightboxData(data)

      let modalName = data.type == 'image' ? 'lightbox' : 'videoModal'
      this.showModal(modalName)
    },
  },
}

//zoom functions
export const zoomFunctions = {
  computed: {
    ...mapState(['modalOpen', 'menuOpen']),
    viewportmeta() {
      return document.querySelector('meta[name="viewport"]')
    },
  },
  methods: {
    resetAndPreventZoom() {
      console.log('%c%s', 'color: blue;', 'reset and prevent zoom')
      this.viewportmeta.content = 'width=device-width, minimum-scale=1.0, maximum-scale=1.0'
    },
    resetAndAllowZoom() {
      console.log('%c%s', 'color: blue;', 'reset and allow zoom')
      this.viewportmeta.content = 'width=device-width, minimum-scale=1.0, maximum-scale=1.0'

      const vm = this
      setTimeout(function () {
        vm.allowZoom()
      }, 300)
    },
    allowZoom() {
      console.log('%c%s', 'color: blue;', 'allow zoom')
      this.viewportmeta.content = 'width=device-width, minimum-scale=1.0, maximum-scale=1.8'
    },
  },
}

//menu button related props
export const menuFunctions = {
  computed: {
    ...mapState(['menuButton', 'menuOpen']),
  },
  methods: {
    ...mapActions(['showMenuButtonAction', 'hideMenuButtonAction']),
  },
}

//check if intro skipped
export const introSkip = {
  computed: {
    ...mapState(['introSkip']),
  },
}

//get dimenions on resize
export const handleResize = {
  data() {
    return {
      window: {
        width: 0,
        height: 0,
        orientation: null,
        fontsize: null,
      },
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  methods: {
    handleResize() {
      this.window.width = window.outerWidth
      this.window.height = window.outerHeight

      this.window.orientation = device ? device.orientation : null

      this.window.fontsize = window.getComputedStyle(document.documentElement).fontSize
    },
  },
}

//store actions & methods to get and set scrollbar width
export const storeScrollBarWidth = {
  data() {
    return {
      scrollbarWidth: 0,
    }
  },
  computed: {
    ...mapState(['scrollBarWidth', 'currentScrollBarWidth']),
    bodyEl() {
      return document.body
    },
    isBrowser() {
      return typeof window !== 'undefined'
    },
  },
  methods: {
    ...mapActions(['toggleStatus']),
    updateScrollBarWidth() {
      if (!this.isBrowser) {
        return null
      }
      this.scrollbarWidth = window.innerWidth - document.documentElement.offsetWidth
    },
    setBodyCss(name, value) {
      if (this.isBrowser) {
        var s = document.body.style
        s[name] = value
      }
    },
    addScrollbarPaddingToStore(customWidth = false) {
      if (this.scrollbarWidth || customWidth) {
        this.toggleStatus({
          type: 'scrollBarWidth',
          status: customWidth ? customWidth : this.scrollbarWidth + 'px',
        })
      }
    },
    removeScrollbarPaddingToStore() {
      this.toggleStatus({
        type: 'scrollBarWidth',
        status: '0px',
      })
    },
  },
}

//basic evet listener functions
export const eventListeners = {
  methods: {
    addEventListeners() {
      //escape
      document.addEventListener('keydown', (e) => this.onEscape(e), false)
      //backdrop click
      document.addEventListener('click', (e) => this.onClick(e), false)
    },
    removeEventListeners() {
      //escape
      document.removeEventListener('keydown', (e) => this.onEscape(e), false)
      //backdrop click
      document.removeEventListener('click', (e) => this.onClick(e), false)
    },
  },
}

//loading and view data related store actions and state
export const storeDataLoading = {
  data() {
    return {
      viewLeaveDuration: 500, //time to clean up stage
      viewEnterDelay: 300, //time to clear loader
      loaderOpenDelay: 500, //time for loader to open across content
      showChild: false,
    }
  },
  computed: {
    ...mapState([
      'viewDataLoaded',
      'viewLoaded',
      'loaderLoaded',
      'viewReady',
      'introShown',
      'showIntro',
      'modalOpen',
      'menuOpen',
      'disableParallax',
    ]),
  },
  watch: {
    viewReady(val) {
      this.viewShow()

      if (!val) {
        this.showChild = false
      }
    },
    modalOpen(val) {
      if (val) {
        this.$modal.push(val)
      } else {
        this.$modal.pop()
      }
    },
  },
  methods: {
    ...mapActions(['loadPartData', 'toggleStatus', 'showModal', 'hideModal', 'getPostsData']),
    //trigger view loaded state to true
    initView() {
      const vm = this

      if (this.loaderLoaded) {
        console.log('%c%s', 'color: CadetBlue;', 'loader ready')
        this.toggleStatus({
          type: 'viewLoaded',
          status: true,
        })

        //trigger viewready manually if showing intro
        //delay for loader to close before starting view show animations etc
        if (!this.showIntro && !this.viewReady) {
          console.log(
            '%c%s',
            'color: cyan;',
            'core set viewReady to TRUE',
            'this.viewReady',
            this.viewReady,
            'this.viewLoaded',
            this.viewLoaded
          )
          setTimeout(function () {
            vm.toggleStatus({
              type: 'viewReady',
              status: true,
            })
          }, 0)
        }
      } else {
        setTimeout(function () {
          vm.initView()
        }, 100)
      }
    },
    //empty function to be overwritten in view
    viewShow() {
      console.log('%c%s', `color: LimeGreen`, 'viewShow')
      this.showChild = true
    },
    viewLeaveAnimations(to, from) {
      return
    },
    leaveView(to, from, next) {
      const vm = this

      this.viewLeaveAnimations(to, from)

      //hide all open modals
      this.hideModal()

      //if going to home and intro not yet show, set it to be shown by loader
      if (!this.introShown && to.path === '/') {
        //dont show the intro if user entered from not home
        this.toggleStatus({
          type: 'introShown',
          status: true,
        })

        //this will show the intro if user entered page on not home and then went home
        // console.log(
        // 	"going to home from another view and intro not yet show, set it to show"
        // );
        // this.toggleStatus({
        // 	type: "showIntro",
        // 	status: true
        // });
      }

      //time to clean up stage
      console.log('leaving view in ' + this.viewLeaveDuration)
      setTimeout(function () {
        vm.toggleStatus({
          type: 'viewReady',
          status: false,
        })

        //allow time for loader to open
        setTimeout(function () {
          next()
        }, vm.loaderOpenDelay)
      }, this.viewLeaveDuration)
    },
    preloadPostImages() {
      if (this.data.posts) {
        let images = []

        this.data.posts.forEach((posts) => {
          if (this.$store.state.data.POSTS[posts.name]) {
            this.$store.state.data.POSTS[posts.name].data.forEach((post) => {
              images.push(post.thumbnail)
            })
          }
        })

        this.preloadImages(images, function () {
          console.log('done preloading post images')
        })
      }
    },
  },
}

//standard before leaving view
export const beforeLeaveRoute = {
  data() {
    return {
      leaving: false,
    }
  },
  beforeRouteLeave(to, from, next) {
    this.leaving = true

    //leave view gracefully
    this.leaveView(to, from, next)
  },
}

//get time now
export const timeNow = {
  methods: {
    now() {
      return Date.now()
    },
  },
}

//preload an array of images with callback
export const loadImages = {
  methods: {
    preloadImages(images, callback) {
      let imageLoaded = 0
      const loadedImages = []
      for (const imageSrc of images) {
        const img = new Image()
        img.src = imageSrc

        img.onload = () => {
          imageLoaded++
          loadedImages.push(img.src)

          if (imageLoaded === images.length) {
            console.log(
              '%c%s',
              'color: DarkSeaGreen;',
              'Done loading ' + images.length + ' images',
              loadedImages
            )
            callback()
          }
        }
      }
    },
  },
}

//wink function
export const winkLogoMixin = {
  data() {
    return {
      winkExt: 'png',
    }
  },
  methods: {
    winkLogo() {
      console.log('%c%s', 'color: CadetBlue;', 'wink logo')
      this.winkExt = 'gif'

      const vm = this
      setTimeout(function () {
        vm.winkExt = 'png'
      }, 900)
    },
  },
}

//chapter
export const chapter = {
  data() {
    return {
      tempTimelineButtonFlag: false,
      currentSection: this.$route.params.section ? Number(this.$route.params.section) : 1,
      currentSlide: this.$route.params.slide,
      data: null,
      viewLeaveDuration: 1100,
      viewEnterDelay: 200,
      loaderOpenDelay: 1000,
      leavingView: false,
      navTimeline: null,
      headerHover: false,
      hoveredPart: null,
      fetchedPartData: null,
    }
  },
  computed: {
    ...mapState(['menuButton', 'scrollBarWidth']),
    ...mapGetters(['getChapterPartBasics']),
    imagesToLoad() {
      return Object.keys(this.data.images).map((key) => this.data.images[key])
    },
    allImagesToLoad() {
      //add timeline and box slider images
      const timelineImages = this.data.timelines
        ? this.data.timelines.items.filter((item) => item.thumb).map((item) => item.thumb)
        : []

      const sliderImages = this.data.sliders
        ? this.data.sliders.slides.filter((item) => item.thumb).map((item) => item.thumb)
        : []

      return this.imagesToLoad.concat(timelineImages, sliderImages)
    },
    storeKey() {
      return `CHAPTER-${this.currentChapter}-${this.currentSection}`
    },
    chapterInfo() {
      return this.getChapterPartBasics[this.currentChapter - 1]
    },
    chapterParts() {
      return this.chapterInfo.parts
    },
    partInfo() {
      return this.chapterParts[this.currentSection - 1]
    },
    prevPart() {
      return this.currentSection == 1 ? false : this.chapterParts[this.currentSection - 2]
    },
    nextPart() {
      return this.currentSection == this.chapterParts.length
        ? false
        : this.chapterParts[this.currentSection]
    },
    nextChapter() {
      return this.currentChapter == this.getChapterPartBasics.length
        ? false
        : this.getChapterPartBasics[this.currentChapter].slug
    },
    lastChapter() {
      return this.currentChapter == this.getChapterPartBasics.length
    },
    blocks() {
      if (this.data.modals) {
        const blocks = this.data.modals.map((modal) => modal.blocks)
        return []
          .concat(...blocks)
          .filter((block) => block.type == 'postslider' && block.data.src == 'blog')
      }
      return false
    },
    postsInModals() {
      if (this.data.posts) {
        return this.data.posts
      }
      if (this.blocks) {
        //extract posts from modals blocks
        return this.blocks.flatMap((block) => block.data)
      }
      return false
    },
  },
  created() {
    //check if valid chapter
    const validChapters = this.$store.state.data.OUTLINE.data.chapters.map((slide) => slide.id)

    if (validChapters.includes(this.$route.params.slide)) {
      //check if valid part
      let chapterIndex = validChapters.indexOf(this.$route.params.slide)

      if (
        !this.$store.state.data.OUTLINE.data.chapters[chapterIndex].parts[
          this.$route.params.section - 1
        ]
      ) {
        return
      }

      this.getPartData()
    } else {
      return
    }
  },
  updated() {
    this.getPartData()
  },
  methods: {
    getPartData() {
      if (this.fetchedPartData === this.storeKey) return

      console.log('%c%s', 'color: gold;', 'getPartData for ', this.storeKey)
      //load relevant data for this chapter
      this.loadPartData({
        url: `/chapters/${this.currentChapter}/${this.currentSection}.json`,
        type: this.storeKey,
      })
      this.fetchedPartData = this.storeKey
    },
    setComponent(section, part) {
      this.viewChapter = section
      this.viewPart = part
    },
    viewLeaveAnimations(to, from) {
      this.resetAndPreventZoom()
      this.leavingView = true
    },
    expandPartMenuHover(val) {
      //return if not desktop
      if (device.type != 'desktop') {
        return
      }

      if (val) {
        this.headerHover = true
      } else {
        const vm = this
        setTimeout(function () {
          vm.headerHover = false
        }, 700)
      }
    },
    expandPartMenuToggle() {
      if (device.type == 'desktop') {
        return
      }
      this.headerHover = !this.headerHover

      clearTimeout(this.sideMenuTimer)

      if (this.headerHover) {
        this.sideMenuTimer = setTimeout(() => {
          this.headerHover = false
        }, 3500)
      }
    },
    sideMenuTimeout() {
      const vm = this
      setTimeout(function () {
        if (vm.headerHover) {
          vm.headerHover = false
        }
      }, 4000)
    },
    createTimeline() {
      if (this.navTimeline) return
      const { header, nav, next } = this.$refs
      const tlNav = new TimelineMax({
        paused: true,
      })

      tlNav
        .set(nav.childNodes, {
          clearProps: 'all',
        })
        .staggerTo(
          header.childNodes,
          0.3,
          {
            y: '+=60',
            autoAlpha: 1,
            ease: Power2.easeInOut,
          },
          -0.1,
          0
        )
        .staggerTo(
          nav.childNodes,
          0.3,
          {
            x: '-=40',
            autoAlpha: 1,
            ease: Power2.easeInOut,
          },
          0.1,
          0
        )
        .to(
          next.childNodes,
          0.3,
          {
            y: '-=60',
            autoAlpha: 1,
            ease: Power2.easeInOut,
          },
          0
        )

      this.navTimeline = tlNav
    },
  },
  watch: {
    menuOpen(val) {
      if (val) {
        this.resetAndPreventZoom()
      } else {
        this.resetAndAllowZoom()
      }
    },
    modalOpen(val) {
      if (val) {
        this.resetAndPreventZoom()
      } else {
        this.resetAndAllowZoom()
      }
    },
    $route(to, from) {
      //modal
      if (to.path === from.path && to.has != from.hash) {
        return
      }

      // Update currentSection only if to.params.section has a value
      if (to.params.section) {
        this.currentSection = Number(to.params.section)
      }

      this.currentSlide = to.params.slide
    },

    viewReady(val) {
      if (val) {
        this.resetAndAllowZoom()
        this.leavingView = false
        this.createTimeline()
        this.navTimeline.delay(0.3).play()

        //preload post images
        this.preloadPostImages()
      } else {
        this.hoveredPart = null
        this.navTimeline.reverse().timeScale(2)
        this.navTimeline = null
      }
    },
  },
}
//chapter part
export const chapterPart = {
  props: ['data', 'leavingView', 'currentChapter', 'part', 'show'],
  data() {
    return {
      tempTimelineButtonFlag: false,
      debugTimeline: false,
      doParallax: false,
      parallaxActive: false,
      parallax: {
        parallax: null,
      },
      itemsToShow: [['showTitle', 300]],
      showInfoBoxes: false,
      showBackground: false,
      showQuote: false,
      showTitle: false,
      showDecal: false,
      showInk: false,
      showDelay: false,
      showDiagram: false,
      showLead: false,
      showPattern: false,
      showImageBox: false,
      showVideoBox: false,
      showMisc: false,
    }
  },
  computed: {
    ...mapState(['viewReady', 'menuOpen', 'modalOpen', 'disableParallax', 'scrollBarWidth']),
    viewCSSId() {
      return `chapter-${this.currentChapter}-${this.part.id}`
    },
    viewCSSClasses() {
      return `view-part part-${this.part.id} section-scene`
    },
    bodyEl() {
      return document.body
    },
    parallaxScalarX() {
      let scalar = 0.2 //desktop

      if (device.type == 'tablet') {
        scalar = 0.55
      } else if (device.type == 'mobile') {
        scalar = 0.56
      }
      return scalar
    },
    parallaxScalarY() {
      let scalar = 0.1 //desktop

      if (device.type == 'tablet') {
        scalar = 0.08
      } else if (device.type == 'mobile') {
        scalar = 0.08
      }
      return scalar
    },
    parallaxOptions() {
      return {
        scalarX: this.parallaxScalarX,
        scalarY: this.parallaxScalarY,
        frictionX: device.type == 'desktop' ? 0.08 : 0.15,
        frictionY: device.type == 'desktop' ? 0.08 : 0.15,
        selector: '.parallax-item',
        limitY: device.type == 'desktop' ? false : 10,
      }
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.viewShow()
      }
    },
    leavingView(val) {
      if (val) {
        this.viewLeave()
      }
    },
    menuOpen(val) {
      if (!val && this.leavingView) {
        return
      } else {
        this.enableParallax(val)
      }
    },
    modalOpen(val) {
      this.enableParallax(val)
    },
  },
  methods: {
    showItems(entering = true, i = 0) {
      if (i == 0) {
        console.log('%c%s', 'color: red;', 'show items')
      }
      if (this.itemsToShow.length == 0) return

      const vm = this
      const items = this.itemsToShow

      if (!entering) {
        this.bodyEl.classList.remove('items-shown')
      }

      if (i <= items.length - 1) {
        const item = items[i]
        const itemDelay = i == 0 ? 0 : items[i - 1][1]
        let delay = entering ? itemDelay : 0

        setTimeout(function () {
          vm[item[0]] = !vm[item[0]]

          vm.showItems(entering, i + 1)
        }, delay)
      } else if (entering && i == items.length) {
        let delay = items[i - 1][1]

        //run parallax after final delay
        setTimeout(function () {
          vm.bodyEl.classList.add('items-shown')
          vm.createParallax()
        }, delay)
      }
    },
    goToTop() {
      this.bodyEl.scrollTop = 0
    },
    viewShow() {
      this.goToTop()
      this.showItems()
    },
    viewLeave() {
      this.enableParallax(true)
      this.showItems(false)
    },
    createParallax() {
      if (this.disableParallax) return

      if (this.doParallax) {
        console.log('%c%s', 'color: red;', 'do parallax')
        const vm = this
        this.parallax.parallax = new this.$parallax(this.$refs.scene, {
          ...vm.parallaxOptions,
        })
        vm.parallaxActive = true
      }
    },
    enableParallax(val) {
      if (this.disableParallax) return

      if (!this.parallax.parallax) return

      val
        ? console.log('%c%s', 'color: red;', 'disable parallax')
        : console.log('%c%s', 'color: red;', 'enable parallax')
      val ? this.parallax.parallax.disable() : this.parallax.parallax.enable()

      this.parallaxActive = val ? false : true
    },
  },
  mounted() {
    //trigger show if already set to true
    console.log('%c%s', 'color: red;', 'show is', this.show)
    if (this.show) {
      this.viewShow()
    }
  },
  created() {
    if (this.debugTimeline) {
      window.addEventListener('keydown', (e) => {
        if (e.key == 'e') {
          if (!this.tempTimelineButtonFlag) {
            this.enableParallax(true)
          }
          this.showItems(this.tempTimelineButtonFlag)

          this.tempTimelineButtonFlag = !this.tempTimelineButtonFlag
        }
      })
    }
  },
}

//chapter part
export const partComponent = {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    timescale: {
      type: Number,
      default: 1,
    },
    timescaleReverse: {
      type: Number,
      default: 1.5,
    },
  },
  data() {
    return {
      timeline: null,
      timelineReverse: null,
    }
  },
  watch: {
    show(val) {
      if (this.timeline) {
        if (val) {
          this.timeline.play().timeScale(this.timescale)
        } else {
          if (this.timelineReverse) {
            console.log('%c%s', 'color: red;', 'timelineReverse play')
            this.timelineReverse.play().timeScale(this.timescaleReverse)
          } else {
            this.timeline.reverse().timeScale(this.timescaleReverse)
          }
        }
      }
    },
  },
  methods: {
    createTimeline() {
      return
    },
  },
  mounted() {
    this.createTimeline()
  },
  beforeDestroy() {
    if (this.timeline) {
      this.timeline.kill()
    }
  },
}
